import { ArticleChart as ArticleChartUI } from "@business-finland/wif-ui-lib/dist/ArticleChart";

import { jcrMultiFieldToArray } from "../../../util/magnolia";

interface IArticleChartRow {
  tdKey: string;
  tdValue: string;
}

interface IArticleChartProps {
  caption?: string;
  thKey: string;
  thValue: string;
  tableData: Wif.Mgnl.NodeWithList<Wif.Mgnl.Node<IArticleChartRow>>;
  credits: string;
  source: string;
}

export function ArticleChart({
  caption,
  thKey,
  thValue,
  tableData,
  credits,
  source,
}: IArticleChartProps): JSX.Element {
  const rows = jcrMultiFieldToArray(tableData).map(
    (tableDataNode: Wif.Mgnl.Node<IArticleChartRow>) => ({
      tdKey: tableDataNode.tdKey,
      tdValue: tableDataNode.tdValue,
    })
  );

  return (
    <ArticleChartUI
      caption={caption}
      thKey={thKey}
      thValue={thValue}
      rows={rows}
      credits={credits}
      source={source}
    />
  );
}
